import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { EProductTemplatesSearchParams } from '@api-ui-app/src/app/e-commerce-product-templates/types/e-product-templates-search-params';
import { EProductTemplatesSearchSortingParams } from '@api-ui-app/src/app/e-commerce-product-templates/types/e-product-templates-search-sorting-params';

@Component({
  selector: 'gd-product-templates-list-search-params',
  templateUrl: './product-templates-list-search-params.component.html',
  styleUrls: ['./product-templates-list-search-params.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductTemplatesListSearchParamsComponent {
  @Input() showSortBy = true;
  @Input() set searchParams(searchParams: EProductTemplatesSearchParams) {
    this.templateName$.next(searchParams?.templateName);
    this.sortingParams$.next(searchParams?.sortingParams);
  }

  @Output() searchParamsChange = new EventEmitter<EProductTemplatesSearchParams>();

  templateName$ = new BehaviorSubject<string>(null);
  sortingParams$ = new BehaviorSubject<EProductTemplatesSearchSortingParams>(null);

  onSortingParamsChange(sortingParams: EProductTemplatesSearchSortingParams) {
    this.sortingParams$.next(sortingParams);
    this.emitSearchParamsChangeEvent();
  }

  onTemplateNameChange(templateName: string) {
    this.templateName$.next(templateName);
    this.emitSearchParamsChangeEvent();
  }

  private emitSearchParamsChangeEvent() {
    this.searchParamsChange.emit({
      templateName: this.templateName$.getValue(),
      sortingParams: this.sortingParams$.getValue(),
    });
  }
}
